"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onlyCountriesCodePhoneNumbers = exports.defaultCountryCodePhoneNumber = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ArrowDropDown_1 = __importDefault(require("@mui/icons-material/ArrowDropDown"));
const Lock_1 = __importDefault(require("@mui/icons-material/Lock"));
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = require("lodash");
const mui_tel_input_1 = require("mui-tel-input");
const pino_1 = __importDefault(require("pino"));
const react_1 = require("react");
const zod_1 = require("zod");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const status_and_notifications_1 = require("../../../../hsbc_img/status_and_notifications");
const FormLabel_1 = require("../../../../material-ui-theme/components/styled/FormLabel");
const StyledMuiTelInput_1 = require("../../../../material-ui-theme/components/styled/StyledMuiTelInput");
const companyQuery_1 = require("../../../../queries/companyQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const userSelectors_1 = require("../../../../selectors/userSelectors");
const setTime_1 = require("../../../../utils/setTime");
const zustandStore_1 = require("../../../../zustandStore");
const slices_1 = require("../../../../zustandStore/slices");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const checkboxSetting_1 = __importDefault(require("../../../molecules/setting/checkboxSetting"));
const drawerAside_1 = __importDefault(require("../../drawerAside"));
const addPeopleAsideState_1 = require("./hooks/addPeopleAsideState");
const logger = (0, pino_1.default)();
const lexico = new lexico_1.default();
const emailSchema = zod_1.z.email();
exports.defaultCountryCodePhoneNumber = 'GB';
const otherCountriesCodePhoneNumbers = ['RO', 'IN', 'MY'];
exports.onlyCountriesCodePhoneNumbers = globalThis.config.IS_PRODUCTION
    ? [exports.defaultCountryCodePhoneNumber]
    : [exports.defaultCountryCodePhoneNumber, ...otherCountriesCodePhoneNumbers];
function handleEmailChange(whiteListedDomains, startTransition, companyFeatures, dispatch, refetchGetUserInfo, setIsEmailBlurred) {
    const debouncedRefetch = (0, lodash_1.debounce)(refetchGetUserInfo, (0, setTime_1.setTime)(1, 'seconds'));
    return event => {
        if (event.target.value == null) {
            dispatch((0, addPeopleAsideState_1.setIsEmailValid)(true));
        }
        else {
            setIsEmailBlurred(false);
            dispatch((0, addPeopleAsideState_1.setEmail)(event.target.value));
            dispatch((0, addPeopleAsideState_1.setEnableCheckUser)(true));
            const enteredEmail = (event.target.value || '').trim().toLowerCase();
            startTransition(() => {
                const domain = enteredEmail.includes('@') ? enteredEmail.split('@')[1] : '';
                const isEmailInWhitelist = whiteListedDomains.includes(domain || '');
                const isEmailValidFormat = emailSchema.safeParse(enteredEmail).success;
                const isEmailValid = companyFeatures?.ENABLE_DOMAIN_WHITELISTING ? isEmailInWhitelist : isEmailValidFormat;
                dispatch((0, addPeopleAsideState_1.setIsEmailValid)(isEmailValid));
                if (isEmailValid && isEmailValidFormat) {
                    void debouncedRefetch();
                }
            });
        }
    };
}
const AddPeopleAside = () => {
    const { role, aside, invitePeople: user, company, setIsAddPeopleAsideOpen, setNotification, setUserSelectedTeam, setInvitedUser, setDialog, } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { roles } = role;
    const { addPeopleAside } = aside;
    const { isOpen: isAddPeopleAsideOpen } = addPeopleAside;
    const [state, dispatch] = (0, react_1.useReducer)(addPeopleAsideState_1.reducer, addPeopleAsideState_1.initialState);
    const saveUserSetting = (0, userQuery_1.useSaveUserSettingQuery)();
    const approverMessage = strings_1.invitePeopleStrings.APPROVER_MESSAGE;
    const { data: userSelectedTeamData } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { data: currentUser } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(currentUser?.companyAccountId || '', { cardprovider: 'tsgo-cardprovider' }));
    const isAmexCardProvider = companyPropertiesData?.cardprovider === 'AMEX';
    const isHsbcCardProvider = companyPropertiesData?.cardprovider === 'HSBC';
    // for hsbc a team admin should invite only users with team member role
    // there is no manager on hsbc as role
    const inviteRoles = (0, react_1.useMemo)(() => {
        return isAmexCardProvider
            ? roles
            : (0, userSelectors_1.isCompanyOrSupportAdmin)(currentUser?.roles || [])
                ? roles
                : { teamMember: roles.teamMember };
    }, [currentUser?.roles, roles, isAmexCardProvider]);
    const { data: checkedUserInfo, refetch: refetchGetUserInfo } = (0, userQuery_1.useGetUserByEmailQuery)(state.email, false);
    const { data: companyFeatures } = (0, companyQuery_1.useGetCompanyFeaturesQuery)();
    const sendUserInvitation = (0, userQuery_1.useSendUserInvitationQuery)();
    const [isEmailBlurred, setIsEmailBlurred] = (0, react_1.useState)(false);
    const { isLoading: isLoadingGetTeamApprovers, data: approvers, refetch: refetchGetTeamApprovers, } = (0, paymentQuery_1.useGetTeamApproversQuery)({
        excludeSelf: false,
        teamId: userSelectedTeamData?.[0] || '',
    });
    const teamId = userSelectedTeamData?.[0] || '';
    const { data: whitelistedDomainsData = [] } = (0, companyQuery_1.useGetCompanyPropertyWhitelistedDomainsQuery)(company.companyId);
    const whiteListedDomains = [...whitelistedDomainsData];
    const [, startTransition] = (0, react_1.useTransition)();
    const [isValidPhoneNumber, setIsValidPhoneNumber] = (0, react_1.useState)(isHsbcCardProvider ? false : true);
    const [isInviteUserPending, setIsInviteUserPending] = (0, react_1.useState)(false);
    const [lastSelectedCountry, setLastSelectedCountry] = (0, react_1.useState)(String(exports.onlyCountriesCodePhoneNumbers[0]));
    const filteredApprovers = (0, react_1.useMemo)(() => isAmexCardProvider
        ? approvers
        : approvers?.filter(approver => approver?.userId !== checkedUserInfo?.userId) || [], [approvers, checkedUserInfo?.userId, isAmexCardProvider]);
    const onRoleChange = (_name, roleId) => {
        if (roleId === 'team_member') {
            dispatch((0, addPeopleAsideState_1.setIsSelfAssigned)(false));
            void refetchGetTeamApprovers();
        }
        else {
            if (filteredApprovers) {
                dispatch((0, addPeopleAsideState_1.setIsSelfAssigned)(filteredApprovers.length === 0));
            }
            else {
                dispatch((0, addPeopleAsideState_1.setIsSelfAssigned)(true));
            }
            if (state.isSelfAssigned) {
                dispatch((0, addPeopleAsideState_1.setRoleId)(addPeopleAsideState_1.defaultApprover.id));
            }
            else {
                dispatch((0, addPeopleAsideState_1.setCurrentApprover)(state.currentApprover));
            }
        }
        dispatch((0, addPeopleAsideState_1.setRoleId)(roleId));
    };
    const submitUserDetails = () => {
        if (isHsbcCardProvider && (!state.phoneNumberValue || !isValidPhoneNumber)) {
            return;
        }
        setIsInviteUserPending(true);
        const payload = {
            username: state.email,
            firstName: state.firstName,
            lastName: state.lastName,
            roleId: state.roleId,
            companyAccountId: '', // always empty ? but it is sent from angularjs like this
            teamId: userSelectedTeamData?.[0] || '',
            approverId: state.isSelfAssigned ? addPeopleAsideState_1.defaultApprover.id : state.currentApprover.id,
        };
        if (isHsbcCardProvider) {
            payload.phoneNumber = state.phoneNumberValue;
            payload.phoneCountryCode = state.phoneCountryCode;
        }
        sendUserInvitation.mutate(payload, {
            onSuccess(userInvited) {
                const successMessage = strings_1.invitePeopleStrings.SUCCESS_MESSAGE({
                    teamId,
                    firstName: userInvited.firstName || state.firstName || '',
                    lastName: userInvited.lastName || state.lastName || '',
                });
                setInvitedUser(userInvited);
                void refetchGetTeamApprovers();
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: successMessage,
                    },
                ]);
                setIsAddPeopleAsideOpen(false);
                dispatch((0, addPeopleAsideState_1.resetState)());
            },
            onError: error => {
                logger.error({ error });
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: `Could not invite ${user.username}`,
                    },
                ]);
            },
            onSettled: () => {
                setIsInviteUserPending(false);
            },
        });
        saveUserSetting.mutate({ selectedTeamID: teamId });
    };
    const checkLoggedUser = () => {
        return state?.roleId === 'manager' || state?.roleId === 'team_admin' || state?.roleId === 'company_admin';
    };
    (0, react_1.useEffect)(() => {
        setUserSelectedTeam(userSelectedTeamData?.[0] || '');
    }, [userSelectedTeamData, setUserSelectedTeam]);
    (0, react_1.useEffect)(() => {
        if (checkedUserInfo && state.enableCheckUser) {
            if (!state.firstName && !state.hasManualEdit.firstName) {
                dispatch((0, addPeopleAsideState_1.setFirstName)(checkedUserInfo.firstName || ''));
            }
            if (isHsbcCardProvider && !state.phoneNumberValue && !state.hasManualEdit.phoneNumberValue) {
                dispatch((0, addPeopleAsideState_1.setPhoneNumber)({
                    phoneNumber: checkedUserInfo?.phoneDetails?.phoneNumber || '',
                    phoneCountryCode: checkedUserInfo?.phoneDetails?.phoneCountryCode || '',
                    phoneNumberValue: checkedUserInfo?.phoneDetails?.fullPhoneNumber || '',
                }));
                const isValidValue = checkedUserInfo?.phoneDetails?.fullPhoneNumber
                    ? (0, mui_tel_input_1.matchIsValidTel)(checkedUserInfo?.phoneDetails?.fullPhoneNumber, {
                        onlyCountries: exports.onlyCountriesCodePhoneNumbers,
                    })
                    : false;
                setIsValidPhoneNumber(isValidValue);
            }
            if (!state.lastName && !state.hasManualEdit.lastName) {
                dispatch((0, addPeopleAsideState_1.setLastName)(checkedUserInfo.lastName || ''));
            }
        }
    }, [
        checkedUserInfo,
        state.enableCheckUser,
        state.firstName,
        state.lastName,
        state.hasManualEdit,
        state.phoneNumberValue,
        isHsbcCardProvider,
    ]);
    (0, react_1.useEffect)(() => {
        if (filteredApprovers && filteredApprovers.length > 0) {
            const teamApprovers = filteredApprovers.length > 0
                ? filteredApprovers.map(approver => {
                    return {
                        label: approver?.fullName || approver?.email,
                        id: approver?.userId,
                    };
                })
                : [];
            dispatch((0, addPeopleAsideState_1.setTeamApprovers)(teamApprovers));
        }
    }, [filteredApprovers]);
    (0, react_1.useEffect)(() => {
        if (state.isSelfAssigned) {
            dispatch((0, addPeopleAsideState_1.setCurrentApprover)(addPeopleAsideState_1.defaultApprover));
        }
        else {
            dispatch((0, addPeopleAsideState_1.setCurrentApprover)({ id: '', label: '' }));
        }
    }, [state.isSelfAssigned]);
    const isSingleRole = Object.keys(inviteRoles).length === 1;
    const singleRoleId = isSingleRole ? Object.values(inviteRoles)[0]?.id : '';
    (0, react_1.useEffect)(() => {
        if (isSingleRole) {
            const roleId = Object.values(inviteRoles)?.[0]?.id || '';
            if (state.roleId !== roleId) {
                dispatch((0, addPeopleAsideState_1.setRoleId)(roleId));
            }
        }
    }, [inviteRoles, isSingleRole, state.roleId]);
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "sendInvitation-button", color: uiConstants_1.UI_BUTTON_PRIMARY, type: "submit", loading: isInviteUserPending, variant: "contained", disabled: isAmexCardProvider ? false : !state.phoneNumberValue || Boolean(state.phoneNumberValue && !isValidPhoneNumber), onClick: submitUserDetails, style: {
                    padding: '8px 22px',
                }, children: strings_1.inputStrings.SEND_INVITATION }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-button", onClick: () => {
                    setIsAddPeopleAsideOpen(false);
                    setLastSelectedCountry(String(exports.onlyCountriesCodePhoneNumbers[0]));
                    setIsValidPhoneNumber(true);
                    dispatch((0, addPeopleAsideState_1.resetState)());
                }, color: uiConstants_1.UI_BUTTON_SECONDARY, label: strings_1.inputStrings.CANCEL })] }));
    return ((0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: "inviteAside", title: strings_1.invitePeopleStrings.INVITE_NEW_USER, open: isAddPeopleAsideOpen, onClose: () => {
            setIsAddPeopleAsideOpen(false);
            setIsValidPhoneNumber(true);
            setLastSelectedCountry(String(exports.onlyCountriesCodePhoneNumbers[0]));
            dispatch((0, addPeopleAsideState_1.resetState)());
        }, footerButtons: footerButtons, children: (0, jsx_runtime_1.jsxs)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: [!isLoadingGetTeamApprovers && state?.roleId === 'team_member' && (filteredApprovers || []).length === 0 ? ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", children: approverMessage })) : null, (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.EMAIL }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { "data-testid": slices_1.invitePeopleUsername, inputProps: {
                                'data-testid': 'email-input',
                            }, id: slices_1.invitePeopleUsername, name: slices_1.invitePeopleUsername, required: true, type: 'email', value: state.email, onBlur: () => setIsEmailBlurred(true), onFocus: () => {
                                setIsEmailBlurred(false);
                                (0, addPeopleAsideState_1.setEnableCheckUser)(false);
                            }, onChange: handleEmailChange(whiteListedDomains, startTransition, companyFeatures, dispatch, refetchGetUserInfo, setIsEmailBlurred) }), !state.isEmailValid && isEmailBlurred && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", sx: { p: 0 }, variant: 'outlined', icon: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusErrorOnLight, { style: { width: '24px', height: '24px' } })) : ((0, jsx_runtime_1.jsx)(Warning_1.default, {})), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                                    color: 'error',
                                }, children: lexico.trc('Validation error message', 'Invalid email domain') }) }))] }), isHsbcCardProvider ? ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0 : '0 10px' }, margin: "normal", children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { id: "phoneNumber", children: "Phone Number *" }), (0, jsx_runtime_1.jsx)(StyledMuiTelInput_1.StyledMuiTelInput, { sx: { padding: 0 }, slotProps: {
                                input: {
                                    name: 'phoneNumber',
                                    required: true,
                                    autoFocus: false,
                                },
                            }, defaultCountry: "GB", onlyCountries: exports.onlyCountriesCodePhoneNumbers, forceCallingCode: true, focusOnSelectCountry: true, error: Boolean(state.phoneNumberValue && !isValidPhoneNumber), MenuProps: { disableAutoFocusItem: true }, value: `${state.phoneCountryCode}${state.phoneNumberValue}`, onChange: (value, info) => {
                                startTransition(() => {
                                    if (value) {
                                        setLastSelectedCountry(`+${info.countryCallingCode}`);
                                        dispatch((0, addPeopleAsideState_1.setPhoneNumber)({
                                            phoneNumber: info.nationalNumber || '',
                                            phoneCountryCode: `+${info.countryCallingCode}`,
                                            phoneNumberValue: value,
                                        }));
                                    }
                                    else {
                                        dispatch((0, addPeopleAsideState_1.setPhoneNumber)({
                                            phoneNumber: '',
                                            phoneCountryCode: lastSelectedCountry,
                                            phoneNumberValue: '',
                                        }));
                                    }
                                    const isValidValue = (0, mui_tel_input_1.matchIsValidTel)(value, { onlyCountries: exports.onlyCountriesCodePhoneNumbers });
                                    setIsValidPhoneNumber(isValidValue);
                                });
                            } }), !isValidPhoneNumber && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: state.phoneNumberValue && !isValidPhoneNumber ? 'error' : 'warning', sx: { p: 0 }, variant: 'outlined', icon: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusErrorOnLight, { style: { width: '24px', height: '24px' } })) : ((0, jsx_runtime_1.jsx)(Warning_1.default, {})), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                                    color: state.phoneNumberValue && !isValidPhoneNumber ? 'error' : 'warning',
                                }, children: lexico.trc('Validation error message', 'A valid phone number is required.') }) }))] })) : null, (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.FIRST_NAME }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { inputProps: {
                                'data-testid': 'firstName-input',
                            }, id: slices_1.invitePeopleFirstName, name: slices_1.invitePeopleFirstName, required: true, type: 'text', value: state.firstName, onChange: event => {
                                dispatch((0, addPeopleAsideState_1.setHasManualEdit)({ ...state.hasManualEdit, firstName: true }));
                                dispatch((0, addPeopleAsideState_1.setFirstName)(event.target.value || ''));
                            } })] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.LAST_NAME }), (0, jsx_runtime_1.jsx)(material_1.OutlinedInput, { inputProps: {
                                'data-testid': 'lastName-input',
                            }, id: slices_1.invitePeopleLastName, name: slices_1.invitePeopleLastName, required: true, type: 'text', value: state.lastName, onChange: event => {
                                dispatch((0, addPeopleAsideState_1.setHasManualEdit)({ ...state.hasManualEdit, lastName: true }));
                                dispatch((0, addPeopleAsideState_1.setLastName)(event.target.value || ''));
                            } })] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.ROLE }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "selectRole-select", name: slices_1.invitePeopleRoleId, required: true, value: state.roleId || (isSingleRole ? singleRoleId : ''), inputProps: { placeholder: strings_1.inputStrings.ROLE_PLACEHOLDER }, onChange: event => {
                                onRoleChange(event.target.name, event.target.value || '');
                                if (event.target.value === 'team_admin' && isHsbcCardProvider) {
                                    setDialog({
                                        type: strings_1.notificationStrings.WARNING,
                                        message: 'Please note that by inviting a Team Owner you are delegating your authority to approve requests for business virtual cards.',
                                        open: true,
                                        actionText: 'OK',
                                        showCancel: false,
                                        onAccept: () => ({}),
                                    });
                                }
                            }, readOnly: isSingleRole, IconComponent: isSingleRole ? () => (0, jsx_runtime_1.jsx)(Lock_1.default, { sx: { marginRight: '8px' }, fontSize: "small" }) : ArrowDropDown_1.default, children: inviteRoles && Object.keys(inviteRoles).length > 0
                                ? Object.keys(inviteRoles).map(roleKey => {
                                    const role = inviteRoles[roleKey];
                                    return role?.id ? ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: role.id, children: role.label }, role.id)) : null;
                                })
                                : null })] }), isAmexCardProvider && state?.roleId && checkLoggedUser() && ((0, jsx_runtime_1.jsx)(checkboxSetting_1.default, { dataTestId: strings_1.inputStrings.ENABLE_SELF_APPROVAL, name: strings_1.inputStrings.ENABLE_SELF_APPROVAL, label: strings_1.inputStrings.ENABLE_SELF_APPROVAL, isChecked: state.isSelfAssigned, disabled: state.isSelfAssigned && filteredApprovers?.length === 0, onChange: () => {
                        dispatch((0, addPeopleAsideState_1.setIsSelfAssigned)(!state.isSelfAssigned));
                    } }, strings_1.inputStrings.ENABLE_SELF_APPROVAL)), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { sx: { pt: 1 }, children: [(0, jsx_runtime_1.jsx)(FormLabel_1.StyledFormLabel, { children: strings_1.inputStrings.APPROVER }), state.isSelfAssigned ? ((0, jsx_runtime_1.jsx)(material_1.Select, { name: slices_1.invitePeopleApproverId, disabled: true, value: addPeopleAsideState_1.defaultApprover.label, children: (0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: addPeopleAsideState_1.defaultApprover.label, children: addPeopleAsideState_1.defaultApprover.label }) })) : filteredApprovers && filteredApprovers?.length > 0 ? ((0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "selectApprover-select", name: slices_1.invitePeopleApproverId, required: true, value: state.currentApprover.id || '', inputProps: { placeholder: strings_1.inputStrings.APPROVER_PLACEHOLDER }, onChange: event => {
                                if (event?.target?.value) {
                                    const selectedApprover = filteredApprovers.find(approver => approver?.userId === event.target.value);
                                    dispatch((0, addPeopleAsideState_1.setCurrentApprover)({ id: event.target.value, label: selectedApprover?.fullName || '' }));
                                }
                            }, children: filteredApprovers &&
                                filteredApprovers.length > 0 &&
                                filteredApprovers?.map(approver => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: approver?.userId, children: approver?.fullName }, approver?.userId))) })) : ((0, jsx_runtime_1.jsx)(material_1.Select, { value: "", disabled: true }))] })] }) }));
};
exports.default = AddPeopleAside;
